import { useContext } from 'react';
import classNames from 'classnames';

import { ConfigContext } from '@providers/ConfigProvider';
import Version from '@components/Version';
import Typography from '@components/atoms/Typography';
import { FormattedMessage } from 'utils/intl';

import messages from './CopyrightFooter.messages';
import classes from './CopyrightFooter.module.scss';

export type Props = {
  className?: string;
  apiVersion?: string;
};

const CopyrightBox = ({ className, apiVersion = '' }: Props): JSX.Element => {
  const { contact } = useContext(ConfigContext);

  return (
    <div className={classNames(classes.copyrightBox, className)}>
      <Typography variant="caption2">
        <FormattedMessage
          {...messages.copyright}
          values={{ year: new Date().getFullYear(), appShortName: contact.appShortName }}
        />
      </Typography>
      <Version apiVersion={apiVersion} />
    </div>
  );
};

export default CopyrightBox;
